
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/__color__",
      function () {
        return require("private-next-pages/__color__/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/__color__"])
      });
    }
  